import React, { useEffect, useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

const InfoPopup = ({
  isOpen,
  toggle,
  message,
  previewFile,
  title,
  size,
  btnClass = "",
  modalFooterClass = "",
  // picture
}) => {
  useEffect(() => {
    console.log("previewFile", previewFile)
  }, [previewFile])

  return (
    <Modal isOpen={isOpen} toggle={toggle} size={size} centered>
      <ModalHeader toggle={toggle} className="text-primary">
        {title}
      </ModalHeader>
      <ModalBody>
        {/* For Preview Image of Register Form Step2  */}
        {previewFile ? (
          <div className="text-center">
            {previewFile.type?.startsWith("image/") ? (
              <img
                src={previewFile.url}
                alt={previewFile.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  borderRadius: "12px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                }}
              />
            ) : (
              <p className="text-muted">Preview not supported</p>
            )}
            <p className="mt-2 small text-muted">{previewFile.name}</p>
          </div>
        ) : (
          // hasPicture
          // Message content for common component
          message && <>{message}</>
        )}
      </ModalBody>
      <ModalFooter className={modalFooterClass}>
        <Button className={btnClass} color="primary" onClick={toggle}>
          Okay
        </Button>
      </ModalFooter>
    </Modal>
  )
}
export default InfoPopup
